import { TIMEZONES, DEFAULT_TIMEZONE } from './timezones';
import { formatTime } from './formatters';

// Get timezone abbreviation
export const getTimezoneAbbr = (timezone = null) => {
  const tz = timezone || localStorage.getItem('orgTimezone') || DEFAULT_TIMEZONE;
  
  const timezoneObj = TIMEZONES.find(t => t.value === tz);
  return timezoneObj?.abbr || 'GST';
};

// Format time with timezone
export const formatTimeWithTZ = (timeString, format = '12h') => {
  const time = formatTime(timeString, format);
  const tzAbbr = getTimezoneAbbr();
  return `${time} ${tzAbbr}`;
};
